import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import {
  change,
  Field,
  getFormSubmitErrors,
  getFormSyncErrors,
  getFormValues,
  reduxForm,
} from "redux-form";
import { LiveSearchSimple } from "../../Components/Form/LiveSearch/LiveSearchSimple";
import { Input, Select } from "../../ui";
import { ButtonPrimary } from "../../Components/Button";
import * as ROUTES from "../../Router/corporate_routes";
import { additionalDataCapture as v } from "./validate";
import CompanyFormModal from "../../Components/corporate/NewCompanyModal";
import {
  isAgency,
  isAgencyAdmin,
  isAgencyUser,
  isRolePlatformAdmin,
  token,
  userAgencyObject,
} from "../../modules/auth";
import {
  companyUnload,
  createCompany,
  createUser,
  fetchBookingDesks,
  fetchCompany,
  fetchCompanyBranches,
  fetchMinimalCompanyUserById,
  unloadCompanyBranches,
} from "../../redux/actions";
import { fetchIndustries } from "../../modules/industries";
import MinimalUserModalForm from "../../Components/Users/MinimalUserModalForm";
import { form } from "./Rfp";
import { nameFormatter } from "../../utils";
import { getAnonymousCompanyFromAgency } from "../../services/anonymousCompanyService";
import CompanyNoteField from "../../Components/corporate/CompanyNoteField";
import Loading from "../../Components/Loading";

const CompanyClientSelector = ({
  change,
  client,
  setClient,
  fetchBookingDesks,
  editEnquiry,
  agencyCode,
  setAgencyCode,
  agency,
  token,
  fetchIndustries,
  industries,
  agencyBookingDesks,
  createUser,
  addClient,
  companyFromEnquiry,
  createCompany,
  fetchCompany,
  companyUnload,
  fetchMinimalCompanyUserById,
  companyBranches,
  fetchCompanyBranches,
  unloadCompanyBranches,
  isRolePlatformAdmin,
  isAgency,
  template,
}) => {
  const searchParams = new URLSearchParams(useLocation().search);
  const clientSearchParam = searchParams.has("client")
    ? searchParams.get("client")
    : null;
  const values = useSelector(getFormValues(form));
  const submitErrors = useSelector(state => getFormSubmitErrors(form)(state));
  const submitFailed = useSelector(state => state.form[form]?.submitFailed);
  const formErrors = useSelector(state => getFormSyncErrors(form)(state));
  const companyIdError = formErrors?.company_id || submitErrors?.company_id;

  const [anonymousCompany, setAnonymousCompany] = useState(null);
  const [company, setCompany] = useState(companyFromEnquiry);
  const [companyBranch, setCompanyBranch] = useState();
  const [companyResultCount, setCompanyResultCount] = useState(0);
  const [showNewCompany, setShowNewCompany] = useState(null);
  const [shouldClearSearches, setShouldClearSearches] = useState(false);
  const [newCompanyModal, setNewCompanyModal] = useState(null);
  const [companySearchUrl, setCompanySearchUrl] = useState(null);
  const [showNewUser, setShowNewUser] = useState(null);
  const [newUserModal, setNewUserModal] = useState(null);
  const [loading, setLoading] = useState(false)
  const [suppressUserNotifications, setSuppressUserNotifications] = useState(
    false
  );
  const fetchAnonymousCompany = async (code) => {
    const { result } = await getAnonymousCompanyFromAgency(
      code,
      token
    );
    if (result) {
      setAnonymousCompany(result);
      return result
    }
  };
  useEffect(() => {
    fetchIndustries(token);
    if (!editEnquiry && searchParams.has("company")) {
      fetchCompany(searchParams.get("company"), token, { minimal: true }).then(
        ({ data }) => {
          const companyFromResponse = data.data;

          if (searchParams.has("client")) {
            fetchMinimalCompanyUserById(
              companyFromResponse?.id,
              searchParams.get("client"),
              token
            );
          }

          setAgencyCode(companyFromResponse?.agency_id);
          change(form, "super_agency_code", companyFromResponse?.agency_id);
          setCompany(companyFromResponse);
        }
      );
    }
    if(!editEnquiry && agency && agency.has_only_dummy_company) {
      setLoading(true)
      fetchAnonymousCompany(
          agency.id,
        ).then((result) => {
          setLoading(false)
        if (result) {
          setAnonymousCompany(result);
          setCompany(result)
        }}).catch((error) => {
        setLoading(false)
      });

    }
    return () => {
      unloadCompanyBranches();
      companyUnload();
    };
  }, []);

  useEffect(() => {
    if (companyFromEnquiry) {
      setCompany(companyFromEnquiry);
    }
  }, [companyFromEnquiry]);

  useEffect(() => {
    setAnonymousCompany(null);
    if (!editEnquiry && !template) {
      clearSearchFields();
      // setShouldClearSearches(true);
    }
    if (agencyCode) {
      if (!editEnquiry) {

        void fetchAnonymousCompany(agencyCode);
      }

      fetchBookingDesks(agencyCode, token, true);
      setCompanySearchUrl(
        window.API + ROUTES.API.COMPANIES.SEARCH + "?code=" + agencyCode
      );
    } else {
      setCompanySearchUrl(null);
    }
  }, [agencyCode]);

  useEffect(() => {
    if (company) {
      fetchCompanyBranches(company?.id, token);
    }
    if (!editEnquiry) {
      // can't change company when editing enquiry
      change(form, "booking_desk_id", null);
      if (company) {
        if (company.is_dummy_company && company.users.length > 0) {
          setClient(company.users[0]);
          change(form, "client_id", company.users[0].id);
        }
        change(form, "company_id", company.id);
        if (template && template?.enquiry?.client) {
          change(form, "client_id", template.enquiry.client.id);
        }
        if (values.company_id) {
          change(
            form,
            "agency_booking_desk_id",
            company.default_booking_desk_id
          );
        }
        // if a company has a sso_method default the suppress_notification checkboxes to true
        if (company.sso_method !== null) {
          setSuppressUserNotifications(true);
        }
      }
    }
  }, [company, values?.company_id]);

  const getClientInitQuery = useCallback(() => {
    if (!client) return;
    return nameFormatter(client, true);
  }, [client]);

  const clearSearchFields = useCallback(() => {
    setCompany(null);
    setClient(null);
    setCompanyResultCount(0);
  }, []);

  const handleCreateCompany = useCallback(formValues => {
    return createCompany(formValues, token).then(() => {
      setNewCompanyModal(false);
      setShowNewCompany(false);
      setClient(null)
      alert(
        "The company was created successfully. Please search for it by name to associate it with your enquiry."
      );
    });
  }, []);

  const handleCreateUser = useCallback(formValues => {
    formValues.append("user_type_id", 1);
    //this was sending either undefined or the company not on selected so hidden it.
    //formValues.append("company_id", company.id);
    return createUser(token, formValues).then(() => {
      setNewUserModal(false);
      setShowNewUser(false);
    });
  }, []);

  const getCompanyBranchesOptions = useCallback(() => {
    let options = [];
    if (companyBranches && companyBranches.length > 0) {
      companyBranches.map(branch => {
        if (branch.deleted_at === null) {
          options.push({
            text: branch.name,
            value: branch.id,
          });
        }
      });
    }
    return options;
  }, [companyBranches]);

  if (!companySearchUrl) return null;
  if(loading) return <Loading />

  return (
    <>
      <div className="row">
        <div className="col md:col-w-4/10">
          {!editEnquiry && (
            <LiveSearchSimple
              key={company?.id || "empty"}
              id={"companySearch"}
              auth
              label="Search Company"
              initQuery={company?.name}
              getText={result => result.name}
              url={companySearchUrl}
              onChange={selectedCompany => {
                setCompany(selectedCompany);
                change(form, "company_id", selectedCompany?.id);
              }}
              onNoResults={result => setShowNewCompany(result)}
              onClear={() => clearSearchFields()}
              setResultCount={setCompanyResultCount}
              shouldClearSearches={shouldClearSearches}
            />
          )}
          {submitFailed && companyIdError && (
            <div className="-mt-4 mb-4">
              <span className={"text-warning font-normal"}>
                {companyIdError}
              </span>
            </div>
          )}
          {editEnquiry && company && (
            <p>
              <strong>{company.name}</strong>
            </p>
          )}
          <div className="hidden">
            <Field
              name="company_id"
              component={Input}
              validate={v.company_id}
            />
          </div>
          {newCompanyModal && (
            <CompanyFormModal
              onSubmit={handleCreateCompany}
              onClose={() => setNewCompanyModal(false)}
              isEdgeEnquiry={values.is_edge_enquiry}
              industries={industries}
              agencyCode={agencyCode}
              agency={agency}
              token={token}
              agencyBookingDesks={agencyBookingDesks}
            />
          )}
        </div>
        {!company && companyResultCount === 0 && (
          <div className="col md:col-w-1/5">
            <div className="md:ml-4 md:mt-5">
              <ButtonPrimary onClick={() => setNewCompanyModal(true)}>
                Create a new Company
              </ButtonPrimary>
            </div>
          </div>
        )}
        {anonymousCompany && !company && !editEnquiry   && (
          <div className="col md:col-w-2/5">
            <div className="md:ml-4 md:mt-5">
              <ButtonPrimary
                style={{ backgroundColor: "#FCA342" }}
                onClick={() => setCompany(anonymousCompany)}
              >
                Use my agency
              </ButtonPrimary>
            </div>
          </div>
        )}
      </div>
      {company && (
        <>
          <div className="row">
            <div className="col">
              {company && !company.is_dummy_company && !client && (
                <span className="text-warning font-normal mb-4 block">
                  Please choose or create a new user for this company
                </span>
              )}
            </div>
            <div className="col md:col-w-2/5">
              <LiveSearchSimple
                key={client?.id || "empty"}
                auth
                disabled={company.is_dummy_company}
                disableClear={company.is_dummy_company}
                initQuery={getClientInitQuery()}
                label="Search Users"
                getText={result =>
                  result.first_name + " " + result.surname + ": " + result.email
                }
                url={`${window.API}/users?companyUser=1&companyId=${company.id}`}
                onChange={addClient}
                query="companyUser"
                onNoResults={result => setShowNewUser(result)}
                onClear={() => setClient(null)}
                shouldClearSearches={shouldClearSearches}
                validate={v.client_id}
              />
              <div className="hidden">
                <Field
                  name="client_id"
                  component={Input}
                  validate={v.client_id}
                />
              </div>
            </div>
            {!client && company && (company.sso_method === null || typeof company.sso_method === 'undefined')  ? (
              <div className="col md:col-w-2/5">
                <div className="md:ml-4 md:mt-5">
                  <ButtonPrimary onClick={() => setNewUserModal(true)}>
                    Create a new User
                  </ButtonPrimary>
                </div>
              </div>
            ) : null}
          </div>
          {getCompanyBranchesOptions().length > 0 ? (
            <div className="row">
              <div className="col md:col-w-2/5">
                <Field
                  name="branch_id"
                  label="Branch"
                  component={Select}
                  options={getCompanyBranchesOptions()}
                  onChange={e => setCompanyBranch(e.target.value)}
                  wrapperClassName="inline mb-8 xl:w-1/2"
                  validate={v.branch_id}
                />
              </div>
            </div>
          ) : null}
          {(isRolePlatformAdmin || isAgency) && company.note ? (
            <CompanyNoteField
              company={company}
              note={company.note}
              displayNote={true}
            />
          ) : null}
        </>
      )}
      {newUserModal && (
        <MinimalUserModalForm
          onSubmit={handleCreateUser}
          onClose={() => setNewUserModal(false)}
          company={company}
          values={values}
          suppressUserNotifications={suppressUserNotifications}
        />
      )}
    </>
  );
};

const mapStateToProps = (state, props) => {
  return {
    ...state.agencyBookingDesks,
    ...state.companyBranches,
    ...state.industries,
    token: token(state),
    agency: userAgencyObject(state),
    companyFromEnquiry: props.companyFromEnquiry
      ? props.companyFromEnquiry
      : state.company?.company || null,
    isRolePlatformAdmin: isRolePlatformAdmin(state),
    isAgency: isAgencyUser(state) || isAgencyAdmin(state),
  };
};

const mapDispatchToProps = {
  fetchIndustries,
  fetchBookingDesks,
  createUser,
  change,
  createCompany,
  fetchCompany,
  companyUnload,
  fetchMinimalCompanyUserById,
  fetchCompanyBranches,
  unloadCompanyBranches,
};

export default reduxForm({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(connect(mapStateToProps, mapDispatchToProps)(CompanyClientSelector));
